import { arrayHelpers } from "@tweddle-se-team/common/helpers";

const { sortStrings } = arrayHelpers;

export const getModelAlias = (
  name,
  marketingNamesConfig,
  locale,
  type = "model"
) => {
  const types = ["model", "modelType"];
  if (
    !types.includes(type) ||
    !marketingNamesConfig[type] ||
    !marketingNamesConfig[type][locale.toUpperCase()]
  )
    return name;
  return marketingNamesConfig[type][locale.toUpperCase()][name] || name;
};

export const sortNames = (marketingNamesConfig = {}, allNames = [], locale) => {
  let localeModels = {};
  if (locale) {
    localeModels = marketingNamesConfig[locale.toUpperCase()] || {};
  }
  const sortedByChoiceNames = Object.keys(localeModels).filter((key) =>
    allNames.includes(key)
  );
  const sortedByAlphabetRemainingNames = sortStrings(allNames).filter(
    (key) => !localeModels[key]
  );
  return [...sortedByChoiceNames, ...sortedByAlphabetRemainingNames];
};
